import React, { useState, useContext } from 'react'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import { MigrantContext } from '../../../contexts/migrantContext'
import { AuthContext } from '../../../contexts/authContext'
import { updateConsumer } from '../../../services/migrantService'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Redirect } from 'react-router-dom'
import { uploadFile } from '../../../services/genericService'
import { changePassword } from '../../../services/genericService'
import 'react-phone-number-input/style.css'
import EditProfileForm from './editProfileForm'

function EditProfilePassLogin() {
  const migrantContext = useContext(MigrantContext)
  const authContext = useContext(AuthContext)
  const [updateSuccesful, setUpdateSuccessful] = useState(false)

  const editProfileDetails = async (
    firstName: string,
    lastName: string,
    avatarURL: string | undefined,
    phonenumber: string,
    avatar: File,
    email: string
  ) => {
    if (avatar) {
      toast.info('Uploading picture..', { autoClose: 2500 })
      avatarURL = (await uploadFile(avatar, 'avatar')) as string
    }

    updateConsumer(firstName, lastName, avatarURL, phonenumber, email).then(
      newProfile => {
        if (newProfile) {
          toast.success('Profile updated.', { autoClose: 1000 })
          migrantContext?.setProfile(newProfile)
          //setUpdateSuccessful(true)
          return true
        } else {
          const message = friendlyMessageFor('error')
          toast.warn(message)
          return null
        }
      }
    )
  }

  const hasProfileChanges = (
    firstName: string,
    lastName: string,
    phonenumber: string,
    avatar: File | null,
    email: string
  ): boolean => {
    if (
      firstName === migrantContext?.profile?.firstName &&
      lastName === migrantContext?.profile?.lastName &&
      phonenumber === migrantContext?.profile?.phonenumber &&
      email === migrantContext?.profile?.email &&
      !avatar
    ) {
      console.log('No changes.')
      return false
    } else {
      console.log('has profile change')
      return true
    }
  }

  const hasPasswordChanged = (
    password: string | undefined,
    newPassword: string | undefined
  ): boolean => {
    if (newPassword !== '' && password !== '') {
      console.log('true')
      return true
    } else {
      console.log('false')
      return false
    }
  }

  const currentPasswordBlank = (
    password: string | undefined,
    newPassword: string | undefined
  ): boolean => {
    if (newPassword !== '' && password === '') {
      toast.warn(friendlyMessageFor('form/passwordblank'))
      return true
    } else {
      return false
    }
  }

  const redirect = () => {
    console.log('Redirecting..')
    setUpdateSuccessful(true)
  }

  const editProfile = async (
    firstName: string,
    lastName: string,
    phonenumber: string,
    avatar: File | null,
    password: string | undefined,
    newPassword: string | undefined,
    email: string
  ) => {
    let hasChanges = false
    let avatarURL: string | undefined = undefined

    new Promise(async (resolve, reject) => {
      if (hasPasswordChanged(password, newPassword)) {
        await changePassword(password!, newPassword!, authContext?.user?.email!)
          .then(result => {
            if (result) {
              toast.success('Changed password!')
              resolve()
            } else {
              console.log(result)
              reject()
            }
          })
          .catch(error => {
            console.log(error.code)
            toast.warn(error.code)
            reject()
          })
      } else if (currentPasswordBlank(password, newPassword)) {
        reject()
      } else {
        resolve(null)
      }
    })
      .then(() => {
        if (
          hasProfileChanges(firstName, lastName, phonenumber, avatar, email)
        ) {
          hasChanges = true

          return editProfileDetails(
            firstName,
            lastName,
            avatarURL!,
            phonenumber,
            avatar!,
            email
          )
        } else {
          console.log('profile no change')
          return redirect()
        }
      })
      .then(() => {
        console.log('Changes?', hasChanges)
        if (hasChanges === true) {
          redirect()
        }
      })
  }

  if (updateSuccesful) return <Redirect to="/profile" />

  return (
    <>
      <EditProfileForm
        editProfile={(
          firstName,
          lastName,
          phonenumber,
          avatar,
          password,
          newPassword,
          email
        ) => {
          editProfile(
            firstName,
            lastName,
            phonenumber!,
            avatar!,
            password,
            newPassword,
            email!
          )
        }}
        isSocial={false}
      />
    </>
  )
}

export default EditProfilePassLogin
